import { css } from '@inter-ikea-kompis/web-component';

/**
 * A class with style.
 */
export default class AccordionStyle {
	/**
	 * Returns styles.
	 *
	 * @returns Styles.
	 */
	public static getStyle(): string {
		return css`
			:host {
				display: block;
			}
		`;
	}
}
